import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UserModel } from "src/app/core/models/entities/user.model";

@Component({
    selector: "app-participants-list",
    styleUrls: ["./participants-list.component.scss"],
    templateUrl: "./participants-list.component.html",
})
export class ParticipantsListComponent {
    @Input() participants: UserModel[] = [];

    @Output() edit = new EventEmitter<UserModel>();
    @Output() remove = new EventEmitter<string>();

    trackById(_: number, item: UserModel): string {
        return item.id;
    }
}
